module.exports = __webpack_public_path__ + "img/2-2.dbb89657.png";